import { render, staticRenderFns } from "./Practice_Management_And_CRM.vue?vue&type=template&id=7899ffdd&scoped=true&"
import script from "./Practice_Management_And_CRM.vue?vue&type=script&lang=js&"
export * from "./Practice_Management_And_CRM.vue?vue&type=script&lang=js&"
import style0 from "./Practice_Management_And_CRM.vue?vue&type=style&index=0&id=7899ffdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899ffdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
